import React from 'react';
import Layout from '../../components/Layout';
import PostsContent from '../../components/Pages/Posts';
import Menu from '../../components/Layout/Menu';

export default function Admins(): JSX.Element | null {
  document.title = `${process.env.REACT_APP_TITLE}: Posts page`;

  return (
    <Layout LeftMenu={Menu} transparent>
      <PostsContent />
    </Layout>
  );
}
